// src/components/Footer.js (VERSÃO FINAL COM i18n)
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // 👈 NOVO IMPORT

function Footer({ visitorCount }) {
  const { t } = useTranslation(); // 👈 NOVO HOOK
  const currentYear = new Date().getFullYear();

  return (
    <footer className='footer'>
      <div className='footer-container'>
        <p>
          &copy; {currentYear}{' '}
          <a
            href='https://www.linkedin.com/in/thiagocostadiniz/'
            target='_blank'
            rel='noopener noreferrer'
          >
            Thiago Costa
          </a>
          . {t('footer_rights_reserved')}
        </p>
        <Link to='/terms'>{t('footer_terms_link')}</Link>

        <div className='contador'>
          <span>{t('footer_visits_label')}:</span>
          <a
            title={t('footer_counter_title')}
            href='https://megacontador.com.br/'
          >
            <img
              src='https://megacontador.com.br/img-xffH5cNHR3gsgtHl-5.gif'
              border='0'
              alt={t('footer_counter_alt')}
            />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
